<template>
    <div class="skills">
        <span v-for="skill in mySkills" :key="skill.name" class="tag skill" :class="skill.type">
            {{ skill.name }}
        </span>
    </div>
</template>

<script>
    export default {
        name: "Skills",
        data () {
            return {}
        },
        props: {
            mySkills: {
                type: Array,
                default: () => { return []; }
            }
        }
    }
</script>

<style lang="sass" scoped>
    .skills
        direction: ltr
        width: 30%
        text-align: center
        margin: 35vh auto

        .primary
            background-color: $pink
        .secondary
            background-color: $green
        .tertiary
            background-color: $purple

        @media screen and (max-width: $mobile-break-point)
            width: 80%
</style>